import logo from './logo.svg';
import './App.css';
import ExamsController from './components/ExamsController';
import AdminController from './components/AdminController';
import AllWeather from './components/weather/AllWeather';
import PetoundaWeather from './components/weather/PetoundaWeather';
import MackenzieWeather from './components/weather/MackenzieWeather';
import { ForecastsController } from './components/ForecastsController';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import TaurusClient from './components/taurus/TaurusClient';

function App() {
    return (
        <Router>
            <div className="App">
                <Switch>
                    <Route path="/admin">
                        <AdminController />
                    </Route>
                    <Route path="/forecasts/:view/:region">
                        <ForecastsController readonly={true} singleregion={true} />
                    </Route>
                    <Route path="/forecasts/:view">
                        <ForecastsController readonly={true} />
                    </Route>
                    <Route path="/forecasts/">
                        <ForecastsController readonly={true} />
                    </Route>

                    <Route path="/weather/current/all">
                        <AllWeather></AllWeather>
                    </Route>
                    <Route path="/weather/current/petounda">
                        <PetoundaWeather></PetoundaWeather>
                    </Route>
                    <Route path="/weather/current/mackenzie">
                        <MackenzieWeather></MackenzieWeather>
                    </Route>
                    <Route path="/taurus/">
                        <TaurusClient />
                    </Route>
                    <Route path="/weather/">
                        <div>weather channel:</div>
                    </Route>

                    <Route path="/">
                        <ExamsController></ExamsController>
                    </Route>
                </Switch>
            </div>
        </Router>
    );
}

export default App;
